var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#34AA4E",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30ZM24.6914 17.5762C25.0096 17.1943 24.958 16.6268 24.5762 16.3086C24.1943 15.9904 23.6268 16.042 23.3086 16.4238L18.9395 21.6667L16.6364 19.3636C16.2849 19.0121 15.7151 19.0121 15.3636 19.3636C15.0121 19.7151 15.0121 20.2849 15.3636 20.6364L18.3636 23.6364C18.5424 23.8152 18.7882 23.9105 19.0408 23.8991C19.2934 23.8876 19.5295 23.7704 19.6914 23.5762L24.6914 17.5762Z",
    fill: "#34AA4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToastIcon);
export default __webpack_public_path__ + "static/media/success-toast-icon.9e3fc1c336bc80b64c1502f3d3ddcaf1.svg";
export { ForwardRef as ReactComponent };